import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { LogoutIcon } from '@heroicons/react/outline';
import { JoveButton, JoveSelect } from '@jove-frontend/mui';
import { AccountBoxOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { OrganizationRoles } from '../../shared/generated';
import { removeAllJoveAppAuthKeys } from '../../utils/auth';
import { useLocalTranslation } from '../../utils/i18nKit';
import { getCurrentUserPortalInfo, jumpToUserPortal, markSelectCommunityUser } from '../../utils/portal';
import { Button } from '../Button/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChooseUserJumpPortalView = function ChooseUserJumpPortalView(props) {
  var className = props.className,
      containerClassName = props.containerClassName,
      confirmJump = props.confirmJump,
      hidePortalListKey = props.hidePortalListKey,
      hideLogoutButton = props.hideLogoutButton,
      user = props.user,
      userRoles = props.userRoles,
      jumpToUserPortalAction = props.jumpToUserPortal,
      productSource = props.productSource,
      forceJumpWhenSelected = props.forceJumpWhenSelected;
  var router = useRouter();

  var _useAuth = useAuth0(),
      logout = _useAuth.logout;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var _useState = useState([]),
      selectPortalList = _useState[0],
      setSelectPortalList = _useState[1];

  var _useState2 = useState(),
      selectPortal = _useState2[0],
      setSelectPortal = _useState2[1];

  var _useState3 = useState([]),
      organizationList = _useState3[0],
      setOrganizationList = _useState3[1];

  var _useState4 = useState(),
      selectOrganization = _useState4[0],
      setSelectOrganization = _useState4[1];

  var _useState5 = useState([]),
      partnerList = _useState5[0],
      setPartnerList = _useState5[1];

  var _useState6 = useState(),
      selectPartner = _useState6[0],
      setSelectPartner = _useState6[1];

  var _useState7 = useState(false),
      loading = _useState7[0],
      setLoading = _useState7[1];

  var _useState8 = useState(false),
      loggingOut = _useState8[0],
      setLoggingOut = _useState8[1];
  /**
   * effects
   */


  useEffect(function () {
    var _portalInfo$portalLis, _portalInfo$organizat, _portalInfo$partnersL;

    var portalInfo = getCurrentUserPortalInfo(user, userRoles, {
      hidePortalListKey: hidePortalListKey,
      productSource: productSource
    });
    setSelectPortalList(portalInfo.portalList);
    setSelectPortal((_portalInfo$portalLis = portalInfo.portalList[0]) === null || _portalInfo$portalLis === void 0 ? void 0 : _portalInfo$portalLis.value);
    setOrganizationList(portalInfo.organizationList);
    setSelectOrganization((_portalInfo$organizat = portalInfo.organizationList[0]) === null || _portalInfo$organizat === void 0 ? void 0 : _portalInfo$organizat.value);
    setPartnerList(portalInfo.partnersList);
    setSelectPartner((_portalInfo$partnersL = portalInfo.partnersList[0]) === null || _portalInfo$partnersL === void 0 ? void 0 : _portalInfo$partnersL.value);
  }, [user, userRoles]);
  /**
   * methods
   */

  var logoutAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!loggingOut) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setLoggingOut(true);
              _context.next = 5;
              return removeAllJoveAppAuthKeys();

            case 5:
              logout({
                logoutParams: {
                  returnTo: window.location.origin
                }
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function logoutAction() {
      return _ref.apply(this, arguments);
    };
  }();

  var clickEnterAction = function clickEnterAction() {
    var item = selectPortalList.find(function (item) {
      return item.value === selectPortal;
    });

    if (item) {
      markSelectCommunityUser(item);
      setLoading(true); // when partner-admin is selected, jump to the portal of the selected partner instead of the default first one

      var jumpItem = item;

      if (selectPortal === 'partner-admin') {
        var partner = partnerList.find(function (item) {
          return item.value === selectPartner;
        });

        if (partner) {
          jumpItem = _objectSpread(_objectSpread({}, item), {}, {
            href: partner.href
          });
        }
      }

      if (jumpToUserPortalAction) {
        jumpToUserPortalAction(jumpItem, {
          organizationSlug: selectOrganization
        });
      } else {
        jumpToUserPortal(router, jumpItem, {
          organizationSlug: selectOrganization,
          forceJump: forceJumpWhenSelected
        });
      }

      confirmJump === null || confirmJump === void 0 ? void 0 : confirmJump();
    }
  };

  var selectPortalChangeAction = function selectPortalChangeAction(value) {
    setSelectPortal(value);
  };

  var selectOrganizationChangeAction = function selectOrganizationChangeAction(value) {
    setSelectOrganization(value);
  };

  var selectPartnerChangeAction = function selectPartnerChangeAction(value) {
    setSelectPartner(value);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col items-center', className),
    children: [!hideLogoutButton && /*#__PURE__*/_jsx(Box, {
      className: "flex w-full items-center justify-end pr-6 pt-6",
      children: /*#__PURE__*/_jsx(Button, {
        color: "primary-outline",
        StartIcon: LogoutIcon,
        loading: loggingOut,
        disabled: loggingOut,
        onClick: logoutAction,
        children: /*#__PURE__*/_jsx("span", {
          children: loggingOut ? $t('text:login.choose_portal.logging_out') : $t('text:navigation.log_out')
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      className: clsx('mt-6 flex flex-col items-center space-y-7', containerClassName),
      children: [/*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col items-center",
        children: [/*#__PURE__*/_jsx(AccountBoxOutlined, {
          className: "text-brand-secondary h-10 w-10"
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          className: "max-w-[440px] text-center font-black",
          children: $t('text:login.choose_portal.multiple_accounts_detected')
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col space-y-3",
        children: [/*#__PURE__*/_jsx(JoveSelect, {
          className: "w-[360px]",
          label: $t('text:login.choose_portal.portal_label'),
          options: selectPortalList,
          value: selectPortal,
          valueChange: selectPortalChangeAction,
          hideCloseBtn: true
        }), selectPortal === OrganizationRoles.ORG_ADMIN && /*#__PURE__*/_jsx(JoveSelect, {
          className: "w-[360px]",
          label: $t('page:brokers.organization'),
          options: organizationList,
          value: selectOrganization,
          valueChange: selectOrganizationChangeAction,
          hideCloseBtn: true
        }), selectPortal === 'partner-admin' && /*#__PURE__*/_jsx(JoveSelect, {
          className: "w-[360px]",
          label: $t('kit:partner'),
          options: partnerList,
          value: selectPartner,
          valueChange: selectPartnerChangeAction,
          hideCloseBtn: true
        })]
      }), /*#__PURE__*/_jsx(JoveButton, {
        variant: "contained",
        className: "w-[120px]",
        onClick: clickEnterAction,
        loading: loading,
        children: $t('text:login.choose_portal.enter')
      })]
    })]
  });
};
export default ChooseUserJumpPortalView;